import "./label_buttons.css";
export function LabelButtons(props) {
    return <div className="label">
        <p>{props.text}</p>
        <div className="label_buttons">
            {props.children}
        </div>
    </div>
}